<template>
  <base-message :message="message"
                :full-width="true"
                :fullscreen="fullscreen">
    <div class="message-body is-block code-message">
      <div class="message-header is-text-white">
        <v-color-icon name="tool" :size="14"></v-color-icon>
        <b>编程练习</b>
      </div>

      <div>
        <div class="columns is-variable is-1">
          <div class="column">
            <div class="code-editor">
              <div v-if="message.data.desc" class="desc">
                <p>{{ message.data.desc }}</p>
              </div>
              <div v-if="message.data.attachments && message.data.attachments.length"
                   class="attachments">
                <attachments
                    :problem="message.data"
                    @download-attachment="$noty.info(`[提示]: 文件可在程序代码中打开`)"></attachments>
              </div>
              <div class="editors">
                <ace-editor
                    v-model="code"
                    class="editor"
                    :ref="'ace-editor-' + _uid"
                    :run="runCode"
                    :auto-height="true"
                    :min-lines="8"
                    :placeholder="message.data.fill === 'manual' ? '' : '在这里编写代码'"
                    :show-placeholder="!code"></ace-editor>
              </div>

              <div class="buttons">
                <button v-if="canStop"
                        class="button is-small is-light"
                        @click="runCode">
                  <v-color-icon v-if="shell.status === 'running'" name="loader"
                                :spin="true"></v-color-icon>
                  <v-color-icon v-else name="play"></v-color-icon>
                  <span v-show="shell.status === 'running'">运行中，中止 (<shell-timer
                      :run="shell.status === 'running'"></shell-timer>)</span>
                  <span v-show="shell.status !== 'running'">运行</span>
                </button>
                <button v-else
                        class="button is-small is-light"
                        @click="runCode"
                        :disabled="shell.status === 'running'">
                  <v-color-icon v-if="shell.status === 'running'" name="loader"
                                :spin="true"></v-color-icon>
                  <v-color-icon v-else name="play"></v-color-icon>
                  <span v-show="shell.status !== 'running'">运行</span>
                  <span v-show="shell.status === 'running'">运行中</span>
                </button>
                <div class="flex-pull-right">
                  <button v-show="message.data.fill === 'manual' && autoFill.status !== 'running'"
                          class="button is-small is-light "
                          @click="autoInput(0)">
                    <span v-show="autoFill.status === 'init'">帮我敲！</span>
                    <span v-show="autoFill.status === 'done'">敲完了！</span>
                    <span v-show="autoFill.status === 'retry'">重新帮我敲…</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="message.data.image" class="column is-6">
            <div class="code-image">
              <zoom-image :image="message.data.image" ></zoom-image>
            </div>
          </div>
        </div>
      </div>


      <div>
        <div class="shell-canvas" >
          <div class="canvas" :id="'turtle-canvas-' + _uid"></div>
        </div>
        <div v-if="shell.output || shell.error" class="shell">
          <code-output
              :output="shell.error || shell.output"></code-output>
        </div>
      </div>
    </div>
    <div v-if="!skip" class="message-bottom">
      <button class="button is-small is-white"
              @click="next">
        <v-color-icon name="arrow-down-s"></v-color-icon>
        <span>继续课堂内容</span>
      </button>
    </div>
  </base-message>
</template>

<script>
import IClassroom from '../../lib/IClassroom.js'
import BaseMessage from '../BaseMessage'
import AceEditor from '@/common/ace_editor/AceEditor'
import CodeOutput from '@/components/classroom/messages/partials/CodeOutput'
import Attachments from '@/components/classroom/messages/partials/Attachments'
import ShellTimer from '@/components/classroom/messages/partials/ShellTimer'
import ZoomImage from '@/components/classroom/messages/partials/ZoomImage'

const IDE = window['IDE']

export default {
  components: { ZoomImage, Attachments, BaseMessage, CodeOutput, AceEditor, ShellTimer },
  props: ['message', 'run', 'canStop'],
  data () {
    return {
      code: '',
      height: 200,
      python: null,
      fullscreen: false,
      IClassroom: IClassroom,
      skip: false,
      autoFill: {
        len: 0,
        status: 'init',
        timer: null
      },
      shell: {
        status: 'init',
        output: '',
        error: '',
        startAt: 0,
        endAt: 0,
        target: 'turtle-canvas-' + this._uid
      }
    }
  },
  mounted () {
    if (this.message.data.fill !== 'manual') {
      this.code = this.message.data.code
    }
  },
  methods: {
    async next () {
      this.skip = true
      IClassroom.requestNextMessage()
    },
    copyToPlayground () {
      IDE.playground.code = this.code
      IDE.playground.active = true
    },
    autoInput (len) {
      if (len === 0) {
        this.autoFill.status = 'running'
        this.code = ''
      }
      if (this.code.length < this.message.data.code.length) {
        this.code += this.message.data.code[len]
        setTimeout(() => {
          this.autoInput(len + 1)
        }, 30)
      } else {
        this.autoFill.status = 'done'
        setTimeout(() => {
          this.autoFill.status = 'retry'
        }, 2000)
      }
    },
    runCode () {
      if (this.code) {
        this.run(this.code, this.shell)
      } else {
        this.$noty.info('编辑器为空')
      }
    }
  }
}
</script>

<style lang="stylus">
.message-content-wrapper {
  .trigger {
    width 100%
  }
}
</style>
<style lang="stylus" scoped>
$r = 5px

.message-body.is-block {
  width 100%
  height 100%
  padding-bottom 0
}

.code-popover {
  display flex
}

.turtle-target {
  background #f5f5f5
}

.desc, .attachments, .buttons {
  padding .75rem
}

.code-image {
  height 100%
  max-height 100%
  background white
  border-radius $r
}

.shell-canvas {
  margin 6px auto 0
  display block
  border-radius $r
  overflow hidden

  .canvas {
    display inline-block
    float left
    background white
    outline none !important
  }
}

.shell {
  padding 6px 0
}

.code-editor {
  overflow hidden
  border-radius $r
  border-left none
  background white
}

.attachments {
  border-top 1px solid #dddddd
}

.editors:not(:first-child) {
  border-top 1px solid #dddddd
}

.buttons {
  margin 0 !important
  border-top 1px solid #dddddd
}

.button {
  margin-bottom 0 !important
}

.editors {
  position relative
  overflow hidden
}

.shadow-editor {
  position absolute
  width 100%
  height 100%
  top 0
  user-select none
  pointer-events none
  opacity .4
}
</style>
